import { orderBy } from 'lodash-es';
import User, { UserViewModel } from 'models/User';
import { createSelector } from 'reselect';
import { RootState } from 'store/store';
import { filter } from 'utils/tables';

import { allSelector, oneSelector } from './orm';

const MODEL_NAME = 'User';

export const getAll = allSelector<UserViewModel>(MODEL_NAME);

export const getOne = oneSelector<User, UserViewModel>(MODEL_NAME);

export const getAllActive = createSelector(getAll, (data) => {
  const users = data.filter(
    (user) => !user.isArchived && user.state === 'signed-up',
  );
  return orderBy(
    users,
    [
      (user) => user.firstName.toLowerCase(),
      (user) => user.lastName.toLowerCase(),
    ],
    'asc',
  );
});

export const getAllActiveWithExclusions = createSelector(
  (state: RootState, exclude: Array<{ id: string }>) => exclude,
  getAllActive,
  (exclude, users) =>
    users.filter(
      (user) => !exclude.some((excludedUser) => excludedUser.id === user.id),
    ),
);

export const searchLocal = createSelector(
  (state: RootState, search: string) => search,
  getAll,
  (search, contacts) => filter(contacts, search, ['firstName', 'lastName']),
);

export const searchLocalActiveUsers = createSelector(
  (state: RootState, search: string) => search,
  getAllActive,
  (search, contacts) => filter(contacts, search, ['firstName', 'lastName']),
);

/**
 * Returns a count of all active users within the instance
 */
export const totalUsers = createSelector(getAll, (users) => {
  return users.filter((user) => !user.isArchived).length;
});
